import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const BreadcrumbContainer = styled.nav `
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
`;
export const BreadcrumbItem = styled.div `
  display: flex;

  &:not(:last-child)::after {
    content: '>';
    margin: 0 8px;
    color: #2f343c;
  }
`;
export const BreadcrumbLink = styled(Link) `
  color: ${(props) => (props.$active ? '#007bff' : '#2F343CB2')};
  font-weight: ${(props) => (props.$active ? '600' : '400')};
  text-decoration: none;
`;
export const BreadcrumbNormal = styled.p `
  color: ${(props) => (props.$active ? '#007bff' : '#2F343CB2')};
  font-weight: ${(props) => (props.$active ? '600' : '400')};
  text-decoration: none;
`;
